// flow ids which correspond to flow definitions and reducers (`identity.flows[FlowId]`)
export var FlowId = {
  BASIC: 'basic',
  ONBOARDING: 'onboarding',
  TU_ACTIVATION: 'TUActivation',
  BILLS_SETUP: 'billshark',
  CREDIT_SCORE: 'credit-score',
  ACCOUNT_AGG: 'account-agg',
  ONBOARDING_GENERIC: 'onboarding-generic',
  ONBOARDING_FORUM: 'onboarding-forum',
  YOUR_CREDIT_CARD: 'yourCreditCard',
  ONBOARDING_DEBT: 'onboarding-debt',
  ANTI_FRAUD: 'anti-fraud',
  SWEEP_VERIFY_NEW_USER: 'sweep-verify-new-user'
}; // ids for a given step (previously called "slug") - `ComponentId` is not always 1:1 with `StepId`
// i.e. the same component might be used with a different set of options for a different step

export var StepId = {
  ENTER_NAME: 'enter-name',
  REGISTER: 'register',
  SIGNIN: 'signin',
  SECURITY_QUESTION: 'security-question',
  GOOGLE_AUTH_REQUIRE_PASSWORD: 'google-auth-require-password',
  THIRD_PARTY_AUTH_REQUIRE_PASSWORD: 'third-party-auth-require-password',
  THIRD_PARTY_AUTH_ID_CONFLICT: 'third-party-auth-id-conflict',
  USER_MUST_SET_PASSWORD: 'user-must-set-password',
  SMS_ENTER_PHONE: 'sms-enter-phone',
  SMS_VERIFY_CODE: 'sms-verify-code',
  CAPTCHA: 'captcha',
  INSTITUTION_SEARCH: 'institution-search',
  YODLEE_LOGIN: 'provider-login',
  YODLEE_MFA: 'provider-mfa',
  YODLEE_ERROR: 'provider-error',
  YODLEE_SUCCESS: 'provider-success',
  YODLEE_LINKING: 'provider-linking',
  // a background step where the Plaid Link modal/iframe should show in front of it
  PLAID_ERROR: 'plaid-error',
  PLAID_LINK: 'plaid-link',
  PLAID_RELINK: 'plaid-relink',
  SYNC_ERROR: 'sync-error',
  PORTAL_MIGRATION_DISCLOSURE: 'portal-migration-disclosure',
  PORTAL_MIGRATION_ACCOUNT_MISMATCH: 'portal-migration-account-mismatch',
  CANCEL_PORTAL_MIGRATION: 'cancel-portal-migration',
  DUPLICATE_INSTITUTION: 'duplicate-institution',
  INSTITUTION_NOT_SUPPORTED: 'institution-not-supported',
  CREDIT_SCORE_BLOCKED: 'credit-score-blocked',
  CREDIT_SCORE_MOBILE_NUMBER: 'credit-score-mobile-number',
  CREDIT_SCORE_SMS_CODE: 'credit-score-sms-code',
  CREDIT_SCORE_BASIC_INFO: 'credit-score-basic-info',
  CREDIT_SCORE_SHORT_SSN: 'credit-score-short-ssn',
  CREDIT_SCORE_FULL_INFO: 'credit-score-full-info',
  CREDIT_SCORE_VERIFICATION_QUESTIONS: 'credit-score-verification-questions',
  BILLS_EXPECTED_SAVINGS: 'bills-expected-savings',
  BILLS_HOW_IT_WORKS: 'bills-how-it-works',
  BILLS_BILL_INFO: 'bills-bill-info',
  BILLS_CONFIRMATION: 'bills-confirmation',
  OG_CHOOSE_INTEREST: 'og-choose-interest',
  OG_QUESTIONS_CREDIT: 'og-questions-credit',
  OG_QUESTIONS_SAVING: 'og-questions-saving',
  OD_ANNUAL_INCOME: 'od-annual-income',
  OD_DEBT_CONFIRMATION: 'od-debt-confirmation',
  YOUR_CC_SELECT_CARD: 'your-cc-select-card',
  YOUR_CC_SUCCESS: 'your-cc-success',
  YOUR_CC_NA: 'your-cc-na',
  ANTI_FRAUD_ERROR: 'anti-fraud-error',
  VERIFY_EMAIL_START: 'verify-email-start',
  VERIFY_EMAIL_SENT: 'verify-email-sent',
  VERIFY_EMAIL_SUCCESS: 'verify-email-success',
  SWEEP_VERIFY_NEW_USER_LOADING: 'sweep-verify-new-user-loading',
  SWEEP_VERIFY_NEW_USER_START: 'sweep-verify-new-user-start',
  SWEEP_VERIFY_NEW_USER_SUCCESS: 'sweep-verify-new-user-success',
  SWEEP_KYC_VERIFY_PERSONAL_INFO: 'sweep-kyc-verify-personal-info',
  SWEEP_KYC_SHORT_SSN: 'sweep-kyc-short-ssn',
  SWEEP_KYC_FULL_SSN: 'sweep-kyc-short-full-ssn',
  SWEEP_KYC_VERIFICATION_RETRY: 'sweep-kyc-verification-retry',
  SWEEP_KYC_CHECK_FOR_TYPOS: 'sweep-kyc-check-for-typos',
  SWEEP_KYC_FAILED: 'sweep-kyc-failed',
  SWEEP_KYC_KBA_ENTRY: 'sweep-kyc-kba-entry',
  SWEEP_KYC_KBA_QUESTIONS: 'sweep-kyc-kba-questions',
  SWEEP_KYC_KBA_ERROR: 'sweep-kyc-kba-error',
  SWEEP_KYC_KBA_DISABLED_ERROR: 'sweep-kyc-kba-disabled-error',
  SWEEP_KYC_KBA_TIMEOUT: 'sweep-kyc-kba-timeout'
}; // web only: used by the `<Auth>` component to map to React components

export var ComponentId = {
  ENTER_NAME: 'ENTER_NAME',
  REGISTER: 'REGISTER',
  SIGNIN: 'SIGNIN',
  SECURITY_QUESTION: 'SECURITY_QUESTION',
  GOOGLE_AUTH_REQUIRE_PASSWORD: 'GOOGLE_AUTH_REQUIRE_PASSWORD',
  THIRD_PARTY_AUTH_REQUIRE_PASSWORD: 'THIRD_PARTY_AUTH_REQUIRE_PASSWORD',
  THIRD_PARTY_AUTH_ID_CONFLICT: 'THIRD_PARTY_AUTH_ID_CONFLICT',
  USER_MUST_SET_PASSWORD: 'USER_MUST_SET_PASSWORD',
  SMS_ENTER_PHONE: 'SMS_ENTER_PHONE',
  SMS_VERIFY_CODE: 'SMS_VERIFY_CODE',
  CAPTCHA: 'CAPTCHA',
  INSTITUTION_SEARCH: 'INSTITUTION_SEARCH',
  YODLEE_LOGIN: 'YODLEE_LOGIN',
  YODLEE_MFA: 'YODLEE_MFA',
  YODLEE_ERROR: 'YODLEE_ERROR',
  YODLEE_SUCCESS: 'YODLEE_SUCCESS',
  PLAID_ERROR: 'PLAID_ERROR',
  PLAID_LINK: 'PLAID_LINK',
  PLAID_RELINK: 'PLAID_RELINK',
  SYNC_ERROR: 'SYNC_ERROR',
  DUPLICATE_INSTITUTION: 'DUPLICATE_INSTITUTION',
  INSTITUTION_NOT_SUPPORTED: 'INSTITUTION_NOT_SUPPORTED',
  PORTAL_MIGRATION_DISCLOSURE: 'PORTAL_MIGRATION_DISCLOSURE',
  PORTAL_MIGRATION_ACCOUNT_MISMATCH: 'PORTAL_MIGRATION_ACCOUNT_MISMATCH',
  CANCEL_PORTAL_MIGRATION: 'CANCEL_PORTAL_MIGRATION',
  CREDIT_SCORE_BLOCKED: 'CREDIT_SCORE_BLOCKED',
  CREDIT_SCORE_MOBILE_NUMBER: 'CREDIT_SCORE_MOBILE_NUMBER',
  CREDIT_SCORE_SMS_CODE: 'CREDIT_SCORE_SMS_CODE',
  CREDIT_SCORE_BASIC_INFO: 'CREDIT_SCORE_BASIC_INFO',
  CREDIT_SCORE_SHORT_SSN: 'CREDIT_SCORE_SHORT_SSN',
  CREDIT_SCORE_FULL_INFO: 'CREDIT_SCORE_BASIC_INFO',
  CREDIT_SCORE_VERIFICATION_QUESTIONS: 'CREDIT_SCORE_VERIFICATION_QUESTIONS',
  BILLS_EXPECTED_SAVINGS: 'BILLS_EXPECTED_SAVINGS',
  BILLS_HOW_IT_WORKS: 'BILLS_HOW_IT_WORKS',
  BILLS_BILL_INFO: 'BILLS_BILL_INFO',
  BILLS_CONFIRMATION: 'BILLS_CONFIRMATION',
  OG_CHOOSE_INTEREST: 'OG_CHOOSE_INTEREST',
  OG_QUESTIONS_CREDIT: 'OG_QUESTIONS_CREDIT',
  OG_QUESTIONS_SAVING: 'OG_QUESTIONS_SAVING',
  OD_ANNUAL_INCOME: 'OD_ANNUAL_INCOME',
  OD_DEBT_CONFIRMATION: 'OD_DEBT_CONFIRMATION',
  YOUR_CC_SELECT_CARD: 'YOUR_CC_SELECT_CARD',
  YOUR_CC_SUCCESS: 'YOUR_CC_SUCCESS',
  YOUR_CC_NA: 'YOUR_CC_NA',
  ANTI_FRAUD_ERROR: 'anti-fraud-error',
  VERIFY_EMAIL_START: 'VERIFY_EMAIL_START',
  VERIFY_EMAIL_SENT: 'VERIFY_EMAIL_SENT',
  VERIFY_EMAIL_SUCCESS: 'VERIFY_EMAIL_SUCCESS',
  SWEEP_VERIFY_NEW_USER_LOADING: 'SWEEP_VERIFY_NEW_USER_LOADING',
  SWEEP_VERIFY_NEW_USER_START: 'SWEEP_VERIFY_NEW_USER_START',
  SWEEP_VERIFY_NEW_USER_SUCCESS: 'SWEEP_VERIFY_NEW_USER_SUCCESS',
  SWEEP_KYC_VERIFY_PERSONAL_INFO: 'SWEEP_KYC_VERIFY_PERSONAL_INFO',
  SWEEP_KYC_SHORT_SSN: 'SWEEP_KYC_SHORT_SSN',
  SWEEP_KYC_FULL_SSN: 'SWEEP_KYC_FULL_SSN',
  SWEEP_KYC_VERIFICATION_RETRY: 'SWEEP_KYC_VERIFICATION_RETRY',
  SWEEP_KYC_CHECK_FOR_TYPOS: 'SWEEP_KYC_CHECK_FOR_TYPOS',
  SWEEP_KYC_FAILED: 'SWEEP_KYC_FAILED',
  SWEEP_KYC_KBA_ENTRY: 'SWEEP_KYC_KBA_ENTRY',
  SWEEP_KYC_KBA_QUESTIONS: 'SWEEP_KYC_KBA_QUESTIONS',
  SWEEP_KYC_KBA_ERROR: 'SWEEP_KYC_KBA_ERROR',
  SWEEP_KYC_KBA_DISABLED_ERROR: 'SWEEP_KYC_KBA_DISABLED_ERROR',
  SWEEP_KYC_KBA_TIMEOUT: 'SWEEP_KYC_KBA_TIMEOUT'
};
export var FlowStoppedReason = {
  COMPLETE: 'COMPLETE',
  CLOSED: 'CLOSED'
}; // Element names to track page impressions in the KYC flow

export var EntityId = {
  SWEEP_VERIFY_NEW_USER_START: 'lets_get_started',
  VERIFY_EMAIL_START: 'email_verification',
  VERIFY_EMAIL_SENT: 'email_verification_sent',
  VERIFY_EMAIL_SUCCESS: 'email_verification_success',
  SMS_ENTER_PHONE: 'add_phone_number',
  SMS_VERIFY_CODE: 'sms_code_verification',
  SWEEP_KYC_VERIFY_PERSONAL_INFO: 'verify_personal_info',
  SWEEP_KYC_SHORT_SSN: 'user_ssn',
  SWEEP_KYC_FULL_SSN: 'full_ssn',
  SWEEP_VERIFY_NEW_USER_SUCCESS: 'onboarding_complete',
  SWEEP_KYC_VERIFICATION_RETRY: 'verification_retry',
  SWEEP_KYC_CHECK_FOR_TYPOS: 'check_for_typos',
  SWEEP_KYC_FAILED: 'kyc_verification_failed',
  SWEEP_KYC_KBA_ENTRY: 'kyc_kba_entry',
  SWEEP_KYC_KBA_QUESTIONS: 'kyc_kba_questions',
  SWEEP_KYC_KBA_ERROR: 'kyc_kba_failed',
  SWEEP_KYC_KBA_DISABLED_ERROR: 'kyc_kba_disabled_failed',
  SWEEP_KYC_KBA_TIMEOUT: 'kyc_kba_timeout',
  CREDIT_SCORE_ACCOUNT_BLOCKED: 'credit_score_account_blocked',
  CREDIT_SCORE_BASIC_INFO: 'credit_score_basic_info',
  CREDIT_SCORE_BLOCKED: 'credit_score_blocked',
  CREDIT_SCORE_FULL_INFO: 'credit_score_full_info',
  CREDIT_SCORE_SHORT_SSN: 'credit_score_short_ssn',
  CREDIT_SCORE_VERIFICATION_QUESTIONS: 'credit_score_verification_questions',
  SECURITY_QUESTION: 'member_onboarding_security_question_prompt',
  // Called Yodlee still despite being for both Plaid and Yodlee institution search for backwards compatible analytics event name matching
  INSTITUTION_SEARCH: 'yodlee_link_accounts',
  YODLEE_LOGIN: 'yodlee_sign_in',
  YODLEE_MFA: 'yodlee_mfa',
  YODLEE_ERROR: 'yodlee_error',
  YODLEE_SUCCESS: 'yodlee_success',
  YODLEE_ACCOUNT_AGGREGATION_INSTITUTION_SEARCH: 'account_aggregation_institution_search',
  YODLEE_ACCOUNT_ENTER_CREDENTIALS: 'yodlee_account_enter_credentials',
  YODLEE_ACCOUNT_ERROR_DETAILS: 'yodlee_account_error_details',
  PORTAL_MIGRATION_DISCLOSURE: 'financial_account_relinking_before_continuing',
  PORTAL_MIGRATION_ACCOUNT_MISMATCH: 'confirm_relinking_financial_account',
  CANCEL_PORTAL_MIGRATION: 'cancel_relinking_financial_account',
  OD_ANNUAL_INCOME: 'od_annual_income',
  OD_DEBT_CONFIRMATION: 'od_debt_confirmation',
  OG_CHOOSE_INTEREST: 'member_onboarding_where_to_start',
  OG_QUESTIONS_CREDIT: 'og_questions_credit',
  OG_QUESTIONS_SAVING: 'og_questions_saving'
};